import { FC } from 'react';
import { useFormContext } from 'react-hook-form';

import { Box } from '@mui/material';

import { RadioControlled } from 'components/_basic/Form/Radio';
import { CurrencyUnitSelector } from 'components/BusinessToolForm/components/CurrencyUnitSelector/CurrencyUnitSelector';
import { useGetPeriodOptions } from 'components/BusinessToolForm/constants/periods';
import { GLOBAL_PERIOD_NAME } from 'components/BusinessToolForm/Sections/Global/form';

import { IPeriodFormHeaderProps } from './types';

import styles from './PeriodFormHeader.module.scss';

export const PeriodFormHeader: FC<IPeriodFormHeaderProps> = ({ disabled, currencyUnitName, periodId }) => {
  const { control } = useFormContext();
  const periodOptions = useGetPeriodOptions();

  return (
    <Box className={styles.header}>
      <RadioControlled
        id={periodId}
        name={GLOBAL_PERIOD_NAME}
        control={control}
        options={periodOptions}
        disabled={disabled}
      />
      <CurrencyUnitSelector name={currencyUnitName} disabled={disabled} />
    </Box>
  );
};
